/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Integrate_EyebrowInputs */

const en_directory_integrate_eyebrow = /** @type {(inputs: Directory_Integrate_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integrate with Seek AI`)
};

const zh_directory_integrate_eyebrow = /** @type {(inputs: Directory_Integrate_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接入 Seek AI`)
};

/**
* | output |
* | --- |
* | "Integrate with Seek AI" |
*
* @param {Directory_Integrate_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_integrate_eyebrow = /** @type {((inputs?: Directory_Integrate_EyebrowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Integrate_EyebrowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_integrate_eyebrow(inputs)
	return zh_directory_integrate_eyebrow(inputs)
});
export { directory_integrate_eyebrow as "directory.integrate.eyebrow" }